import { CommonModule } from "@angular/common";
import { User } from "./../../interfaces/user/user.model";
import { signal } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig } from "primeng/dynamicdialog";
import { ChipModule } from "primeng/chip";
import { TooltipModule } from "primeng/tooltip";
import { AccordionModule } from "primeng/accordion";

@Component({
    selector: "app-view-profile-data",
    imports: [CommonModule, ChipModule, TooltipModule, AccordionModule],
    templateUrl: "./view-profile-data.component.html",
    styleUrl: "./view-profile-data.component.css",
})
export class ViewProfileDataComponent implements OnInit {
    user = signal<User | null>(null);
    abilities: { tag: string; descriptions: string[] }[] = [];
    constructor(private config: DynamicDialogConfig) {}
    ngOnInit(): void {
        this.user.set(this.config.data);
        this.groupedAbilities();
    }

    groupedAbilities() {
        const groupedAbilities = this.user()?.data.roles[0].abilities.reduce((acc: any, ability) => {
            if (!acc[ability.tag]) {
                acc[ability.tag] = [];
            }
            acc[ability.tag].push(ability.description);
            return acc;
        }, {});

        this.abilities = Object.keys(groupedAbilities).map((tag) => ({
            tag: tag,
            descriptions: groupedAbilities[tag],
        }));
    }
}
